import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Tooltip, Paper } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import Delete from '@material-ui/icons/Delete';

import MaterialTable from 'material-table';
import tapaStyles from "./tapa.module.css";
import commonStyles from '../common/common.module.css';
import bino from '../../assets/bino.svg';
import linkIcon from '../../assets/link_blue.svg';
import unlink from '../../assets/unlink.png';
import OrderDashboard from '../../models/OrderDashboard';
import DotIcon from '@material-ui/icons/Lens';
import moment from 'moment';


const styles = (theme: Theme) =>

  createStyles({
    green: {
      color: 'green !important',
      fontSize: '14px'
    },
    red: {
      color: 'red !important',
      fontSize: '14px',
    },
    relative: {
      position: 'relative'
    },
    linkButton2: {
      background: 'white',
      border: 'none'
    },
    linkButton: {
      transform: 'rotate(140deg)',
      width: '20px',
      cursor: 'pointer'
    },
    tableIcon: {
      height: '20px',
      width: 'auto',
      paddingRight: '10px',
      color: "var(--primaryblue)",
      'img&':{
        paddingBottom: '2px',
        height: '16px',
      },
      ' &:last-child': {
        paddingRight: '0px'
      }
    },
    formControlIcon:{
      '& svg':{
        fontSize: '18px',
      }
    },
    formControlLabel:{
      fontSize: '13px',
    },
    formControl: {
      justifyContent: 'flex-end',
      width: '99%',
      marginRight: '20px',
    },
    orderNumberDisplay: {
      padding: '1px 1px 2px 1px'
    }
  });

interface tapaCompletedInspectionListProps {
  classes: any;
  openForm: (type: string, id?: number) => void;
  tapaForms: Array<any>;
  selectedOrder: OrderDashboard;
  editForm: (id: number) => void;
  handleSubmit: (type: string, orderNumber: string, tapaId?: number) => void;
  openConfirmation: (type: string, tapaId: number, orderNumber: string) => void;
  print: (id: number) => void;
};

const PADDING_RIGHT_CELLS = '14px';
const PADDING_LEFT_CELLS = '10px';
const cellStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };
const headerStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };

const tapaCompletedInspectionList = (props: tapaCompletedInspectionListProps) => {

  const { classes } = props;

  return (    
    <div className= { `${ commonStyles.wrapper } ${ tapaStyles.wrapper }` }>
      <h3 className={ commonStyles.header} >TAPA List</h3>

      <MaterialTable
        components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

        data={ props.tapaForms }
        columns={[ 

          { title: 'Order #', field: 'order_number', cellStyle, headerStyle, render: (rowData: any) => {
         
            const orderRender = rowData.orders.map((el: any) => <div className={ classes.orderNumberDisplay }>{el.number}</div>);
            return <div className={ classes.relative }><button className={ classes.linkButton2 } disabled={ !props.selectedOrder.id } onClick={() => props.openForm('link', rowData.id) }><img alt="logo" src={ linkIcon } className={ props.classes.linkButton } /></button> { orderRender }</div>;
          } 
          },
          { title: 'Driver', field: 'driver_name', cellStyle, headerStyle },
          { title: 'Carrier', field: 'carrier', cellStyle, headerStyle, 
          },
          {
            title: 'Truck Plate', field: 'truck_number', cellStyle , headerStyle
          },
          { title: 'Inspection Date / Time', field: 'create_date', cellStyle, headerStyle
          },
          { title: 'Status', field: 'status', cellStyle, headerStyle, render: (rowData: OrderDashboard) => {
            const colorClass: any = classes[rowData.color_status];
            return <DotIcon className={ colorClass } />;
          }
          }, 
          {
            title: 'Action',
            headerStyle: { textAlign: 'center' },
            cellStyle: { minWidth: '100px', textAlign: 'center' },
            render: (rowData: any) => {
              return (
                <span className={ classes.awbActionsList }>
                  <Tooltip title=''>
                    <img src={ bino } alt="" className={ classes.tableIcon } onClick={ () => props.editForm(rowData.id) } />
                  </Tooltip>
                  <Tooltip title=''>
                    <PrintIcon className={ classes.tableIcon } onClick={ () => props.print(rowData.id) }/>
                  </Tooltip>
                  <Tooltip title='Delete'>
                    <Delete className={ classes.tableIcon } onClick={ () => props.openConfirmation('delete', rowData.id, rowData.order_number) } />
                  </Tooltip>
                  <Tooltip title=''>
                    <img alt="logo" src={ unlink } className={ props.classes.linkButton } onClick={ () => props.openForm('vieworders', rowData.id) }/>
                  </Tooltip>
                </span>
              );
            },
          },
        ]}

        options={{
          paging: false,
          pageSize: 10,
          maxBodyHeight: '400px',
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          pageSizeOptions: [15, 20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  );
  
};

export default withStyles(styles)(tapaCompletedInspectionList);
